import script from "./CategoriasFinanceirasAdministrar.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoriasFinanceirasAdministrar.vue?vue&type=script&setup=true&lang=js"

import "./CategoriasFinanceirasAdministrar.vue?vue&type=style&index=0&id=3791956c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3791956c"]])

export default __exports__